import React, { Component } from 'react'
import { Col, Row, Label, Button, Collapse } from 'reactstrap'
import { observer } from 'mobx-react'
import { formatNullableValue } from '../../../../../utils/formatar';
import { IconeSetaSubir, IconeSetaDescer } from '../../../../comum/components/Icones';

@observer
export default class CardExportacao extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;

        this.state = {
            collapsed: false,
            selecionado: this.props.data.Pagar
        }

        this.handleCollapse = this.handleCollapse.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleCollapse() {
        this.setState({
            collapsed: !this.state.collapsed
        })
    }

    renderFields(col) {
        if(col.formatter) {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue( col.formatter(this.props.data[col.dataField], this.props.data))}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue(this.props.data[col.dataField], this.props.data)}
                    </div>
                </div>
            );
        }
    }

    handleClick(event) {
        if(this.props.click && !event.target.className.includes("btn") && this.props.data.HabilitarPagamento){
            this.setState({
                selecionado: !this.state.selecionado
            },() => {
                this.props.click(this.props.data)
            })
        }
    }
    
    render() {
        return (
            <Col xs={12} md={6} lg={4} className="px-0" onClick={ this.handleClick }>
                <div className={` card-navio ${this.state.selecionado ? "card-marcado" : ""}`}>
                    <Row xs={12} className="px-0">
                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                            </div>
                        </Col>

                        {
                            this.props.colunas.map((col, index) => 
                            (col.dataField !== this.props.titulo) &&
                            <Col xs={col.dataField === "Legenda" ? 12 : 6} className="px-0" key={index}>
                                {this.renderFields(col)}
                            </Col>
                            )
                        }
                        
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/components/CardExportacao.js